const apiConfig = {



    "baseUrl": "https://reports.tibura.services:3095",

    "appName": "Identti Front End",

    "apiKey": "apiKey",

    "secrect": "secrect",
}
export default apiConfig;